// Per-stat writable stores, split out from stores.js. This module has no
// dependency on jobs.js/jobEngine.js/effects.js/stores.js — it exists so that
// jobs.js, jobEngine.js, and effects.js can import stat stores directly here
// instead of from stores.js. stores.js imports jobs.js at its top, and
// jobs.js/jobEngine.js/effects.js reference stat stores as bare identifiers
// in module-top-level data literals (job dailyEffects/requirements/promotion,
// STAT_META); if those literals imported the stats from stores.js, the
// resulting stores.js -> jobs.js -> ... -> stores.js cycle would force this
// module's body to run before stores.js had defined them, throwing
// "Cannot access '<stat>' before initialization" (TDZ). stores.js re-exports
// everything below so other files can keep importing stats from './stores.js'
// unchanged.
import { writable } from 'svelte/store';

function clamp(x) {
    return Math.max( 0., Math.min(x, 1.) )
}

function writableStat(value) {
    const { subscribe, set, update } = writable(value);

    return {
        subscribe,
        update: (callback) => update(n => clamp(callback(n))),
        set: (value) => set(clamp(value))
    };
}

// character stats
export const health = writableStat(0.6);
export const energy = writableStat(0.6);
export const hygiene = writableStat(0.75);
export const culture = writableStat(0.2);
export const iq = writableStat(0.2);
export const loneliness = writableStat(0.2);
export const confidence = writableStat(0.2);
export const stress = writableStat(0.7);
export const alcoholism = writableStat(0.6);
export const drugs = writableStat(0.1);
export const smooth = writableStat(0.3);
export const honesty = writableStat(0.5);
export const optimism = writableStat(0.5);
export const fitness = writableStat(0.3);

// skills and experience stats
export const construction = writableStat(0.0);
export const media = writableStat(0.0);
export const journalism = writableStat(0.0);
export const bass = writableStat(0.0);
export const guitar = writableStat(0.0);
export const sax = writableStat(0.0);
export const keys = writableStat(0.0);
export const drums = writableStat(0.0);
export const meditation = writableStat(0.0);
export const welding = writableStat(0.0);
export const basic_law = writableStat(0.0);
export const basic_cooking = writableStat(0.0);
export const people_skills = writableStat(0.0);
export const public_speaking = writableStat(0.0);
export const police_experience = writableStat(0.0);
export const italian = writableStat(0.0);
export const french = writableStat(0.0);
export const pickpocket = writableStat(0.0);
export const driving = writableStat(0.0);
export const crime = writableStat(0.0);
export const dance_basic = writableStat(0.0);
export const dance_intermediate = writableStat(0.0);
export const dance_advance = writableStat(0.0);
export const dance_experience = writableStat(0.0);

// home stats
export const home_cleanliness = writableStat(0.8);
